import { extendTheme } from '@chakra-ui/react';

// Define the font family for the entire application
const theme = extendTheme({
  fonts: {
    heading: '"TT Interphases Pro", Inter, sans-serif',
    body: '"TT Interphases Pro", Inter, sans-serif',
  },
  // You can add other theme customizations here
  styles: {
    global: {
      // Global styles for the body
      body: {
        fontFamily: '"TT Interphases Pro", Inter, sans-serif',
      }
    }
  }
});

export default theme; 